
import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';

const CreateSubCategory = () => {
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ category_id: '', name: '' });
  const [editId, setEditId] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchSubcategories = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/subcategories/getSubcategories`); // Update API path if needed
    setSubcategories(response.data);
  };

  const fetchCategories = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/getCatecory`); // Update API path if needed
    setCategories(response.data);
  };

  useEffect(() => {
    fetchSubcategories();
    fetchCategories();
  }, []);

  const handleOpen = (subcategory = null) => {
    setOpen(true);
    if (subcategory) {
      setEditId(subcategory.id);
      setFormData({ category_id: subcategory.category_id, name: subcategory.name });
    } else {
      setEditId(null);
      setFormData({ category_id: '', name: '' });
    }
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    if (editId) {
      await axios.put(`${API_BASE_URL}/api/subcategories/updateSubcategory/${editId}`, formData);
    } else {
      await axios.post(`${API_BASE_URL}/api/subcategories/subcategoriesStore`, formData);
    }
    fetchSubcategories();
    handleClose();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this subcategory?')) {
      await axios.delete(`${API_BASE_URL}/api/subcategories/getSubcategories/${id}`);
      fetchSubcategories();
    }
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={() => handleOpen()}>
        Add Subcategory
      </Button>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Parent Category</TableCell>
              <TableCell>Child Category</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subcategories.map((subcategory) => (
              <TableRow key={subcategory.id}>
                <TableCell>{subcategory.id}</TableCell>
                <TableCell>{subcategory.category?.name || 'N/A'}</TableCell>
                <TableCell>{subcategory.name}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpen(subcategory)}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(subcategory.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editId ? 'Edit Subcategory' : 'Add Subcategory'}</DialogTitle>
        <DialogContent>
          <TextField
            select
            margin="dense"
            label="Category"
            fullWidth
            value={formData.category_id}
            onChange={(e) => setFormData({ ...formData, category_id: e.target.value })}
            SelectProps={{ native: true }}
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>{category.name}</option>
            ))}
          </TextField>
          <TextField
            margin="dense"
            label="Name"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} color="primary">{editId ? 'Update' : 'Add'}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateSubCategory;
